import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';

export default function getNumberInvalidRecipients(
    recipientWell: RecipientWellWithFindControlViewState
): number {
    let countInvalid = 0;
    for (let recipient of recipientWell.recipients) {
        countInvalid += recipient.isValid ? 1 : 0;
    }
    return countInvalid;
}
